import React, { useState } from 'react'

const useFlow = ({ onBack = () => {}, onSubmit = () => {}, initialStep = 0, initialValues = {} }) => {
    const [step, setStep] = useState(initialStep)
    const [formValues, setValues] = useState(initialValues)

    const onChange = (id) => (value) => {
        setValues((prev) => ({
            ...prev,
            [id]: value,
        }))
    }

    const onClickChange = (id) => (value) => {        
        onChange(id)(value)
        setStep((prev) => prev+1)
    }

    const handleBack = () => {
        if (step === 0) {
            onBack()
            return
        }
        
        setStep((prev) => prev-1)
    }

    const finalStageSubmit = (id) => (values) => {
        if (values === undefined) {
            onSubmit(formValues)
            return    
        }
        onSubmit({...formValues, [id]: values})
    }

    const incrementStep = () => {
        setStep((prev) => prev+1)
    }

    const decrementStep = () => {
        setStep((prev) => prev-1)
    }

    return {
        finalStageSubmit,
        handleBack,
        onClickChange,
        onChange,
        incrementStep,
        decrementStep,
        formValues,
        step,
        setStep
    }
}

export default useFlow